export const numberConverter = {
  input: (value: string) => (isNaN(Number(value)) ? 0 : Number(value)),
  output: (value: number) => value.toString(),
}
